/**
 * The `next` redirect after login, accepted only as a path on this site. Anything else (`https://…`,
 * protocol-relative `//host`, or `/\host`, which browsers read as `//host`) would send the reviewer to
 * another site after they sign in, so it falls back to `fallback`.
 */
export const safeNextPath = (raw: string | null | undefined, fallback: string): string => {
  if (!raw || !raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) {
    return fallback;
  }
  return raw;
};
